export const TEXTTYPE = {
  EDITOR: "editör",
  INPUT: "input",
};
